import { useContext } from 'react';
import LayoutContext, { ProviderContext } from './LayoutContext';

const useLayout = (): ProviderContext => useContext(LayoutContext)
export default useLayout;